import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TipHeading } from "./TipHeading";
import { TipText } from "./TipText";
export const SecondTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ _jsx(TipHeading, {
                className: headingClassName,
                children: "Be entertaining and helpful"
            }),
            /*#__PURE__*/ _jsx(TipText, {
                children: "Offer stories, tips and insights, and find ways to inspire other travelers to follow in your footsteps."
            })
        ]
    });
};
